import React, { Component } from 'react';
import IconComponent from '../portal/iconComponent';

export default class SearchBox extends Component {

    constructor(props) {

        super(props);

        this.searchButtonType = {
            search: {
                iconName:'magnifying-glass-search-icon',
                title:this.props.keywords.searchLibrary,
                id:1,
                dataCy: 'search-button'
            },
            clear: {
                iconName:'close-icon',
                title:this.props.keywords.clear,
                id:2,
                dataCy: 'clear-button'
            }
        };

        this.searchOptions = {
            delaySearchTime:500
        };


        this.state = { 
            searchBoxIconName: 'magnifying-glass-search-icon',
            searchBoxTitle: this.props.keywords.searchLibrary,
            searchBoxClassName: 'search-box',
            searchText: '',
            selectedSearchButtonType: this.searchButtonType.search
         };
        
    }

    searchButtonClick(event) {

        if(this.state.selectedSearchButtonType.id == this.searchButtonType.clear.id) {
                this.setState({
                    searchText: '',
                    selectedSearchButtonType:this.searchButtonType.search
                });
                this.clearSearch(event);
        }
    }

    searchTextChangeHandler(searchText, event) {
        
        this.setState({searchText});
        
        if(this.searchOptions.timeoutHandler){
            clearTimeout(this.searchOptions.timeoutHandler);
        }

        if (searchText == '') {
            this.clearSearch(event);
            this.updateSearchButtonState(this.searchButtonType.search);
        }
        else {
            this.searchOptions.timeoutHandler = setTimeout(
                function(){
                    this.searchText(searchText, event);
                }.bind(this),
                this.searchOptions.delaySearchTime);
        }
    }

    clearSearch(event) {

        if(this.props.sendSearchEvent){
            this.props.search(event);
        }
        else {
            this.props.search();
        }
        
    }

    searchText(searchText, event) {

        this.updateSearchButtonState(this.searchButtonType.clear);
        
        if(this.props.sendSearchEvent) {

            this.props.search(event);
        }
        else {

            this.props.search(searchText);
        }
    }

    updateSearchButtonState(searchButton) {

        this.setState({ 
            selectedSearchButtonType: searchButton
        });
    }

    /**
     * it's necessary in order to be supported as a grid search
     */
    getValue() {

        return this.state.searchText;
    }

    render() {

        return(
            <div className={this.state.searchBoxClassName}>
                <input
                    placeholder={this.props.keywords.searchLibrary} 
                    type='text' 
                    value={this.state.searchText} 
                    onChange={(event) => this.searchTextChangeHandler(event.target.value, event)}
                    data-cy={this.props.dataCy ? this.props.dataCy : 'search-user-field'}
                />
                <span className='search-button' data-cy={this.state.selectedSearchButtonType.dataCy} onClick={(event) => this.searchButtonClick(event)}>
                    <IconComponent iconClassName={this.state.selectedSearchButtonType.iconName} 
                        title={this.state.selectedSearchButtonType.title} />
                </span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portal/searchBox.jsx